// extracted by mini-css-extract-plugin
export default {"meatBall":"MeatBallIcon_meatBall__jT9Fd"};